import React, { useContext, useState } from "react";
import ReactFlagsSelect from "react-flags-select";
import { Link } from "react-router-dom";
import { AppContext } from "../main";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY_MODUPE);

const Server = (props) => {
  const { handleEditItem } = props;
  const { appState } = useContext(AppContext);

  const defaultPricings = {

  };

  const {
    pricings = defaultPricings,
    editMode = false,
  } = appState;

  // console.log('pricnings',pricings)

  const [selectedFlags, setSelectedFlags] = useState(Array(pricings?.plans?.length).fill("GB"));
  const [isYearly, setIsYearly] = useState(false);

  const handleSelect = (index, countryCode) => {
    setSelectedFlags((prevFlags) => {
      const updatedFlags = [...prevFlags];
      updatedFlags[index] = countryCode;
      return updatedFlags;
    });
  };

  if (!(pricings?.options && pricings?.plans)) {
    return null;
  }

  const handlePayment = async (priceId) => {
    try {
      const stripe = await stripePromise;

      // Redirect to Stripe Checkout
      const { error } = await stripe.redirectToCheckout({
        lineItems: [
          {
            price: priceId, // The ID of the price you created in Stripe dashboard
            quantity: 1,
          },
        ],
        mode: 'subscription',
        successUrl: window.location.origin + '/success',
        cancelUrl: window.location.origin + '/cancel',
      });

      if (error) {
        console.error(error);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const priceId = process.env.REACT_APP_STRIPE_PRODUCT_ID_MODUPE

  return (
    <>
      <div className="de-gradient-edge-top"></div>
      <div className="de-gradient-edge-bottom"></div>
      <div className="container z-9">
        <div className="row">
          <div className="col-lg-6 offset-lg-3 text-center">
            <div className="subtitle fadeInUp mb-3">{pricings.title}</div>
            <h2 className="fadeInUp mb20">{pricings?.subtitle}</h2>
            <div className="switch-set d-flex justify-content-center align-items-center">
              <span className="me-2">{pricings?.leftPlan || 'Monthly Plan'}</span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={isYearly}
                  onChange={() => setIsYearly((prev) => !prev)}
                />
                <span className="slider round"></span>
              </label>
              <span className="ms-2">{pricings?.rightPlan || 'Yearly Plan'}</span>
            </div>
            <div className="spacer-20"></div>
          </div>

          <div className="row">
            {pricings?.plans.map((plan, index) => (
              <div key={index} className="col-xl-3 col-md-6 mb-sm-30 fadeInRight">
                <div className={`de_pricing-table type-2 ${plan.bestSeller ? "rec" : ""} ${isYearly ? "active" : ""}`}>
                  {plan.bestSeller && <div className="d-recommend">Best Seller</div>}
                  <div className="d-head">
                    <h3>{plan.slots}</h3>
                  </div>
                  <div className="d-price">
                    <h4 className="opt-1">${plan.monthly}<span>/mo</span></h4>
                    <h4 className="opt-2">${plan.yearly}<span>/mo</span></h4>
                    <p>{pricings?.labels?.normalPrice} <s>${plan.original}</s></p>
                  </div>
                  <div className="d-location">
                    <h4>{pricings?.labels?.serverLocation}</h4>
                    <ReactFlagsSelect
                      className="flags"
                      countries={pricings?.options?.map((opt) => opt.name)}
                      customLabels={Object.fromEntries(pricings?.options?.map((opt) => [opt.name, opt.title]))}
                      selected={selectedFlags[index]}
                      onSelect={(countryCode) => handleSelect(index, countryCode)}
                      searchable={false}
                    />
                  </div>
                  <div className="d-group">
                    <h4>{pricings?.labels?.topFeatures}</h4>
                    <ul className="d-list">
                      {plan.features?.map((feature, i) => (
                        <li key={i}>{feature?.name}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="d-action">
                    <button
                      onClick={() => handlePayment(plan?.priceId)} // Replace with actual price ID
                      className="btn-main opt-1 w-100"
                    >
                      {plan.button}
                    </button>
                    <button
                      onClick={() => handlePayment(plan?.priceId)} // Replace with actual price ID
                      className="btn-main opt-2 w-100"
                    >
                      {plan.button2}
                    </button>
                    <p>{pricings?.notes?.renewText}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>
        {`
          .switch {
            position: relative;
            display: inline-block;
            width: 40px;
            height: 20px;
          }

          .switch input {
            opacity: 0;
            width: 0;
            height: 0;
          }

          .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #ccc;
            transition: 0.4s;
            border-radius: 20px;
          }

          .slider:before {
            position: absolute;
            content: "";
            height: 14px;
            width: 14px;
            left: 3px;
            bottom: 3px;
            background-color: white;
            transition: 0.4s;
            border-radius: 50%;
          }

          input:checked + .slider {
            background-color: #2196F3;
          }

          input:checked + .slider:before {
            transform: translateX(20px);
          }

          @media (max-width: 768px) {
            .switch-set {
              flex-direction: column;
              align-items: center;
              text-align: center;
            }

            .d-head h3, .d-price h4, .d-location h4 {
              font-size: 1.2rem;
            }

            .d-list li {
              font-size: 1rem;
            }

            .btn-main {
              font-size: 1rem;
              padding: 8px;
            }
          }
        `}
      </style>
    </>
  );
};

export default Server;